import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formError' })
export class FormErrorPipe implements PipeTransform {
  public transform(errors: any): string {
    const keys: string[] = Object.keys(errors);
    if (keys.length === 0) return '';

    const key: string = keys[0];
    const value: any = errors[key];
    switch (key) {
      case 'required':
        return 'value is required';

      case 'email':
        return 'Value must be email';
    }
    return 'Value is not valid';
  }
}
